import $api from "./openapi";

type UseGetAccountingSystemOrganizationsArgs = {
  teamSlug?: string;
  accountingSystemOrganizationId?: string;
  enabled?: boolean;
};

export default function useGetAccountingSystemOrganizations({
  teamSlug,
  accountingSystemOrganizationId,
  enabled = true,
}: UseGetAccountingSystemOrganizationsArgs) {
  return $api.useQuery(
    "get",
    "/api/teams/{team_slug}/accounting_system/organizations/{accounting_system_organization_id}",
    {
      params: {
        path: {
          team_slug: teamSlug!,
          accounting_system_organization_id: accountingSystemOrganizationId!,
        },
      },
    },
    { enabled: !!teamSlug && enabled },
  );
}
